import { render, staticRenderFns } from "./expressForwardingInformation.vue?vue&type=template&id=21fb96f2&scoped=true"
import script from "./expressForwardingInformation.vue?vue&type=script&lang=js"
export * from "./expressForwardingInformation.vue?vue&type=script&lang=js"
import style0 from "./expressForwardingInformation.vue?vue&type=style&index=0&id=21fb96f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb96f2",
  null
  
)

export default component.exports